import { useCallback } from 'react';

import { useEffectOnce } from 'src/lib/hooks';
import { usePopups } from 'src/lib/popups';

import { GenericNotificationPopup } from './GenericNotificationPopup';

export const GENERIC_NOTIFICATION_POPUP = Symbol('GENERIC_NOTIFICATION');

export const useGenericNotificationPopup = () => {
  const popups = usePopups();

  useEffectOnce(() => {
    popups.registerPopup(GENERIC_NOTIFICATION_POPUP, GenericNotificationPopup);
  });

  const openGenericNotificationPopup = useCallback(
    ({ notification, onButtonClick, onClose }) => {
      popups.openPopup(GENERIC_NOTIFICATION_POPUP, {
        notification,
        onButtonClick: (linkFromNotification) => {
          popups.closePopup(GENERIC_NOTIFICATION_POPUP);
          onButtonClick(linkFromNotification);
        },
        onClose,
      });
    },
    [popups]
  );

  return {
    openGenericNotificationPopup,
  };
};
